import { useFormContext } from "react-hook-form";

import { FieldSetInputProps } from "components/voc";
import styled from "styled-components";

import RadioOn from "assets/images/radio_btn_on.png";
import RadioOff from "assets/images/radio_btn_off.png";
import React, { InputHTMLAttributes, useState } from "react";
import { createImportSpecifier } from "typescript";

type FieldRadioProps = FieldSetInputProps & { labelText?: string };

const FieldRadioStyled = styled.span`
  display: flex;
  margin: 1rem 3rem 1rem 0;

  .label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .label::before {
    width: 2.2rem;
    height: 2.2rem;
    margin-right: 1rem;
    background: url(${RadioOff}) no-repeat center;
    background-size: 2.2rem;
    content: "";
  }

  input[type="radio"]:checked + .label::before {
    background-image: url(${RadioOn});
    content: "";
  }
`;

const FieldRadio = ({ name, labelText, defaultChecked, ...props }: FieldRadioProps) => {
  const { register, setValue } = useFormContext();
  const [checkedState, setCheckedState] = useState(defaultChecked);
  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    // safari unchecked 대응
    if (checkedState) {
      setValue(name!, null);
    } else {
      setValue(name!, props.value);
    }

    setCheckedState(!checkedState);

    if (props.className?.includes("uncheck-disable") && checkedState) {
      setValue(name!, props.value);
      setCheckedState(checkedState);
    }
  };

  return (
    <>
      <FieldRadioStyled className="c_radio">
        <input {...register(name!)} {...props} onClick={handleClick} checked={checkedState} />
        <label htmlFor={props.id} className="label">
          {labelText}
        </label>
      </FieldRadioStyled>
    </>
  );
};

export default FieldRadio;
